// react imports
import { useEffect, useState } from "react";
import { Pagination, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import axios from "axios";

// common imports
import { API_URL } from "common/constants/config";
import GarbageIcon from "common/svg/GarbageIcon";

// styled-components imports
import DeleteButton from "./styled-components/DeleteButton";

import CategoryHeader from "./CategoryHeader";
import "./css/Pagination.css";
import "./css/Table.css";

function Users() {
  interface User {
    id: string;
    email: string;
    name: string;
  }

  interface UserData extends Omit<User, "id"> {
    key: string;
  }

  const [users, setUsers] = useState<UserData[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [count, setCount] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [query, setQuery] = useState<string>("");

  const columns: ColumnsType<UserData> = [
    {
      title: "Correo electrónico",
      key: "email",
      dataIndex: "email",
      align: "center",
      width: 320,
    },
    {
      title: "Nombre",
      key: "name",
      dataIndex: "name",
      align: "center",
      width: 280,
    },
    {
      title: "Eliminar",
      align: "right",
      render: (value) => (
        <DeleteButton onClick={deleteUser(value.key)}>
          <GarbageIcon />
        </DeleteButton>
      ),
    },
  ];

  function handleCountSelect(value: number) {
    setCount(value);
  }

  function handleQueryChange(value: string) {
    setQuery(value);
  }

  function handlePageChange(value: number) {
    setPage(value);
  }

  async function fetchUsers() {
    const {
      data: { users: usersResponse, total: totalResponse },
    } = await axios.get(`${API_URL}/admin/users`, {
      params: {
        count,
        page,
        q: query,
      },
    });

    const mappedUsers: UserData[] = usersResponse.map(
      ({ id, name, email }: User) => ({
        key: id,
        email,
        name,
      })
    );

    setUsers(mappedUsers);
    setTotal(totalResponse);
  }

  function deleteUser(id: string) {
    return async () => {
      const response = await axios.delete(`${API_URL}/admin/users/${id}`);
      if (response.status === 200) {
        setUsers(users.filter((user) => user.key !== id));
        setTotal(total - 1);
      }
    };
  }

  useEffect(() => {
    fetchUsers();
  }, [count, page, query]); // eslint-disable-line

  return (
    <>
      <CategoryHeader
        title="Usuarios"
        onSelect={handleCountSelect}
        onSearch={handleQueryChange}
      />
      <Table
        columns={columns}
        dataSource={users}
        pagination={false}
        className="action-padding"
      />
      <Pagination
        current={page}
        pageSize={count}
        total={total}
        showSizeChanger={false}
        onChange={handlePageChange}
      />
    </>
  );
}

export default Users;
